import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleEditModal, toggleNeedRefresh, setModalViewActualTab, setViewedUser  } from '../../store/userTabSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';

import Spinner from '../../components/components/spinner/spinner.jsx';



import { ReactComponent as StarFilled } from '../../components/icons/star-filled.svg';
import { ReactComponent as StarEmpty } from '../../components/icons/star-empty.svg';

import {
    getHeaders,
    headerWidthsForUserOpinions,
    tabsConfig,
    buttonsConfig,
    leftSideConfig,
    rightSideConfig,
    empty,
} from './userOpinionsTableConfig.js';


import './User.css';
import apiService from "../../components/api_services/apiService";
import Table from "../../components/list2/table";
import {headerWidths} from "./userTableConfig";
import customText from "../../components/components/custom_text/customText";
import UniversalLineWithComponents
    from "../../components/components/universal_line_with_components/universalLineWithComponents";
import CustomText from "../../components/components/custom_text/customText";


function ViewUser() {
  const dispatch = useDispatch();

  const isModalOpen = useSelector((state) => state.users.editModalOpen);
  const modalViewActualTab = useSelector((state) => state.users.modalViewActualTab);
  const viewedUser = useSelector((state) => state.users.viewedUser);
  const [opinionsRows, setOpRows] = useState([]);

  const modalViewTabs = [
      "Dane podstawowe",
      "Dane dodatkowe",
      "Dyscypliny",
      "Opinie",
      "Płatności",
  ]

  const [refresh, setRefresh] = useState(false);


  const [formData, setFormData] = useState({

    isForDeleting: false,
    deletingDate: null,

    //first
    id: '',
    name: '',
    createdAt: '',
    email: '',
    phoneNumber: '',
    password: '***********',
    role: '',

    //second
    sex: '',
    gpsPoint: '',
    yearOfBirth: '',
    profilePhoto: '',
    otherPhotos: [],

    //third
    mostPracticedSport:'',
    otherSports: [
    ],

    //fourth
    avgScore: 0,
    numberOfOpinions: 1263,
    opinions: [
        // {
        //     id:1,
        //     addingDate:'',
        //     senderUserName:'',
        //     senderUserId:'',
        //     avgScore:1,
        //     actions:''
        // },

    ],

    //fifth
    payments: [],

  });

    const [blocked, setBlocked] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // Stan loadera

    const handleOpinionRowClick = (row) => {
        const senderId = row[5];
        if (senderId) {
            dispatch(setViewedUser(senderId));
            dispatch(setModalViewActualTab(modalViewTabs[0])); // Przełącz na "Dane podstawowe"
        }
    };

    const handleZablokujOblokuj = () => {
        setIsLoading(true); // Włącz loader
        try {
            ApiService.toggleHasBlocked(viewedUser);
            dispatch(toggleNeedRefresh());
            setRefresh(!refresh);
        } catch (error) {
            console.error('Błąd podczas blokowania/odblokowywania:', error);
        } finally {
            setIsLoading(false); // Wyłącz loader
        }

    }

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    // Dodaj useEffect, który zaktualizuje formData gdy viewedUser się zmieni
    useEffect(() => {

        setIsLoading(true); // Włącz loader na początku

        if (viewedUser) {
            // Pobierz dane użytkownika
            const fetchUserData = async () => {
                try {
                    // Pobierz dane użytkownika
                    const responseData = await ApiService.getUserData(viewedUser);
                    console.log('Otrzymane dane z API:', responseData);
                    const responseDataPayments = await ApiService.getUserPayments(viewedUser);
                    console.log('Otrzymane dane płatności z API:', responseDataPayments);
                    const responseDataOpinions = await ApiService.getUserOpinions(viewedUser);
                    console.log('Otrzymane dane Opinii z API:', responseDataOpinions);
                    const responseDataOpinionsStats = await ApiService.getUserOpinionsStats(viewedUser);
                    console.log('Otrzymane dane Opinii z API:', responseDataOpinionsStats);
                    
                    // Mapowanie płci z API na format wyświetlania
                    const sexMapping = {
                        'MALE': 'Mężczyzna',
                        'FEMALE': 'Kobieta',
                        'OTHER': 'Inna'
                    };



                    // Pobierz dane lokalizacji, jeśli są dostępne koordynaty
                    let gpsPointString = '';
                    if (responseData.profile && responseData.profile.geoCoordinates) {
                        try {
                            const geoCodingResponse = await ApiService.geoCoding(
                                responseData.profile.geoCoordinates.longitude,
                                responseData.profile.geoCoordinates.latitude
                            );
                            gpsPointString = geoCodingResponse.locationName || '';
                            console.log('Pobrana lokalizacja:', gpsPointString);
                        } catch (geoError) {
                            console.error('Błąd podczas geokodowania:', geoError);
                        }
                    }

                    
                    // Przygotowanie tablicy zdjęć
                    const otherPhotos = responseData.profile && responseData.profile.otherPhotosUrls 
                        ? [...responseData.profile.otherPhotosUrls] 
                        : [];

                    // Pobieranie danych sportów pojedynczo dla każdego sportSkill
                    const sportPromises = [];
                    const sportSkills = responseData.profile?.sportSkills || [];

                    // Tworzymy tablicę promises dla każdego sportu
                    for (const skill of sportSkills) {
                        sportPromises.push(ApiService.getSportById(skill.sportId));
                    }

                    // Pobieramy dane o najczęściej uprawianym sporcie (jeśli istnieje)
                    if (responseData.profile?.mostPracticedSport) {
                        sportPromises.push(ApiService.getSportById(responseData.profile.mostPracticedSport));
                    }

                    // Czekamy na wszystkie zapytania
                    const sportsData = await Promise.all(sportPromises);

                    // Tworzymy mapę sportów na podstawie otrzymanych danych
                    const sportsMap = {};
                    let mostPracticedSportData = null;

                    // Jeśli istnieje mostPracticedSport, to ostatni element w sportsData to jego dane
                    if (responseData.profile?.mostPracticedSport) {
                        mostPracticedSportData = sportsData.pop();
                        sportsMap[responseData.profile.mostPracticedSport] = mostPracticedSportData;
                    }

                    // Mapujemy pozostałe dane sportów
                    sportSkills.forEach((skill, index) => {
                        if (sportsData[index]) {
                            sportsMap[skill.sportId] = sportsData[index];
                        }
                    });

                    // Mapowanie umiejętności sportowych
                    const otherSports = [];
                    if (responseData.profile && responseData.profile.sportSkills) {
                        responseData.profile.sportSkills.forEach(skill => {
                            const sportData = sportsMap[skill.sportId];

                            if (sportData) {
                                otherSports.push({
                                    icon: sportData.iconUrl || `/images/default-sport-icon`,
                                    name: sportData.name || `Sport ID: ${skill.sportId}`,
                                    score: skill.skillLevel || 0
                                });
                            }
                        });
                    }

                    // Określenie najczęściej uprawianego sportu
                    const mostPracticedSportName = mostPracticedSportData ? mostPracticedSportData.name : '';

                    // Aktualizuj formData z wszystkimi danymi
                    setFormData({
                        isForDeleting: responseData.isForDeleting,
                        deletingDate: responseData.dateOfDeletion ? responseData.dateOfDeletion.substring(0, 10) : '',
                        // Dane podstawowe
                        id: responseData.profile ? responseData.profile.userId : '',
                        name: responseData.profile ? responseData.profile.name : '',
                        createdAt: responseData.dateOfCreation ? responseData.dateOfCreation.replace('T', ' ').substring(0, 19) : '',
                        email: responseData.email || '',
                        phoneNumber: responseData.phoneNumber || 'Brak numeru telefonu',
                        password: '***********', // Zawsze ukryte
                        role: responseData.profile && responseData.profile.accountPlan === 'TESTER' ? 'TESTER' : 'USER',

                        // Dane dodatkowe
                        sex: responseData.profile ? sexMapping[responseData.profile.sex] || '' : '',
                        gpsPoint: gpsPointString,
                        yearOfBirth: responseData.profile ? responseData.profile.yearOfBirth?.toString() || '' : '',
                        profilePhoto: responseData.profile ? responseData.profile.profilePhotoUrl || '' : '',
                        otherPhotos: otherPhotos,

                        // Dyscypliny
                        mostPracticedSport: mostPracticedSportName,
                        otherSports: otherSports,

                        // Opinie - brak danych w responseData
                        avgScore: responseDataOpinionsStats.avgScore,
                        numberOfOpinions: responseDataOpinionsStats.opinionsCount,
                        opinions: responseDataOpinions ? responseDataOpinions.map(opinion => [
                            opinion.id,
                            opinion.addedOn ? opinion.addedOn.replace('T', ' ').substring(0, 19) : '-',
                            opinion.senderName || '-',
                            <>
                                {[...Array(opinion.scoreLevel > 5 ? 5 : opinion.scoreLevel)].map((_, index) => (
                                    <StarFilled key={index} />
                                ))}
                                {[...Array(5 - (opinion.scoreLevel > 5 ? 5 : opinion.scoreLevel))].map((_, index) => (
                                    <StarEmpty key={index} />
                                ))}
                            </>,
                            '',
                            opinion.opinionSenderId
                        ]) : [],

                    //         opinions: [{
                    //     id:1,
                    //     addingDate:'',
                    //     senderUserName:'',
                    //     senderUserId:'',
                    //     avgScore:1,
                    //     actions:''
                    // },

                            // [
                            // [1,
                            //     '22.01.2024',
                            //     'Ktoś',
                            //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'
                            //     }}>
                            //         {[...Array(5)].map((_, index) => (
                            //             <StarFilled />
                            //         ))}
                            //         {[...Array(5 - 5)].map((_, index) => (
                            //             <StarEmpty />
                            //         ))}
                            //     </div>,
                            // ],
                            // [2,
                            //     '22.01.2024',
                            //     'Ktoś',
                            //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'
                            //
                            //     }}>
                            //         {[...Array(3)].map((_, index) => (
                            //             <StarFilled />
                            //         ))}
                            //         {[...Array(5 - 3)].map((_, index) => (
                            //             <StarEmpty />
                            //         ))}
                            //     </div>
                            // ]],

                        // Płatności - brak danych w responseData
                        payments: responseDataPayments && responseDataPayments.payments ? responseDataPayments.payments.map(payment => [
                            payment.id,
                            payment.createdAt ? payment.createdAt.replace('T', ' ').substring(0, 19) : '-',
                            `${payment.amount?.formatted || '0'} ${payment.amount?.currency?.toUpperCase() || ''}`,
                            payment.status,
                            payment.description || payment.paymentType
                        ]) : [],
                    });
                    try {
                        const hasBlockedResponse = await ApiService.getHasBlocked(viewedUser);
                        console.log('Otrzymane dane z API:', hasBlockedResponse);
                        setBlocked(hasBlockedResponse);
                    } catch (error) {
                        console.error('Błąd:', error);
                    }
                } catch (error) {
                    console.error('Błąd podczas pobierania danych użytkownika:', error);
                }
            };
            
            fetchUserData();
        }

        setIsLoading(false); // Włącz loader na początku

    }, [viewedUser, refresh]);



    useEffect(() => {
    const isValid = formData.name.trim() !== '';
    setIsSubmitDisabled(!isValid);
  }, [formData, modalViewActualTab]); // Monitoruj zmiany w `formData`

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let iconUrl = null;

      if (formData.thumbnail) {
        const uploadedImagePath = await ApiService.uploadImage(formData.thumbnail);
        iconUrl = uploadedImagePath;
      }

      const sportData = {
        name: formData.name,
        nameEng: formData.englishName,
        iconUrl: iconUrl,
      };

      const response = await ApiService.addNewSport(sportData);
      console.log('Nowy sport został dodany:', response);

      dispatch(toggleEditModal());
      dispatch(toggleNeedRefresh());
    } catch (error) {
      console.error('Błąd podczas dodawania nowego sportu:', error);
    }
  };

  const handleCloseModal = () => {
    dispatch(toggleEditModal());
  };

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleImageNavigation = (direction) => {
    if (direction === 'next' && currentImageIndex + 3 < formData.otherPhotos.length) {
      setCurrentImageIndex(prevIndex => prevIndex + 3);
    } else if (direction === 'prev' && currentImageIndex > 0) {
      setCurrentImageIndex(prevIndex => Math.max(0, prevIndex - 3));
    }
  };

  return (
    <Modal isOpen={isModalOpen} onClose={handleCloseModal} className={blocked === true ? "modal-content-3" : "modal-content-2" }>

        {isLoading && <Spinner size="medium" color="#007bff" />}

        <h2>Użytkownik{blocked === true ? " - zablokowany" : "" }{formData.isForDeleting ? <span className={'red-color'}> oznaczony do usunięcia </span> : ''}
            {formData.deletingDate ? <span className={'red-color'}> w dniu {formData.deletingDate}</span> : ''}</h2>
      <div className="userView-menu">
        {
          modalViewTabs.map((tab, index) => {
            return (
              <button
                type={modalViewActualTab === tab ? "modal-menu-active" : "modal-menu"}
                id={index}
                key={index}
                className={modalViewActualTab === tab ? "buttons-modal-appearance" : ""}
                onClick= {() => dispatch(setModalViewActualTab(tab))}>{tab}</button>)

          })
        }
      </div>
      {/*------------------------------------------------------------*/}

    {/* DODANY KONTENER PRZEWIJANIA - START */}
    <div className="user-view-scrollable-content">
      { modalViewActualTab === "Dane podstawowe" && <>
        <form onSubmit={handleSubmit}>
          <div className="userView">
            <label htmlFor="id" className="userView">ID</label>
            <input
              className="userView"
              type="text"
              id="id"
              name="id"
              value={formData.id}
              onChange={handleInputChange}
              readOnly={true}
            />
          </div>
          <div className="userView">
            <label htmlFor="name" className="userView">Nazwa</label>
            <input
              className="userView"
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              readOnly={true}
            />
          </div>
          <div className="userView">
            <label htmlFor="createdAt" className="userView">Utworzony dnia</label>
            <input
                className="userView"
                type="text"
                id="createdAt"
                name="createdAt"
                value={formData.createdAt}
                onChange={handleInputChange}
                readOnly={true}
            />

          </div>
          <div className="userView">
            <label htmlFor="email" className="userView-1">Email</label>
            <input
                className="userView"
                type="text"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                readOnly={true}
            />
              <button className="buttons-modal-appearance2-almost-white" type="button" onClick={handleCloseModal}>
                  Wyślij link aktywacyjny email
              </button>
          </div>
          <div className="userView">
            <label htmlFor="phoneNumber" className="userView-2">Numer telefonu</label>
            <input
                className="userView"
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                readOnly={true}
            />
              <button className="buttons-modal-appearance2-almost-white" type="button" onClick={handleCloseModal}>
                  Wyślij kod SMS
              </button>
          </div>
          <div className="userView">
            <label htmlFor="password" className="userView-3">Hasło</label>
            <input
                className="userView"
                type="text"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                readOnly={true}
            />
              <button className="buttons-modal-appearance2-almost-white" type="button" onClick={handleCloseModal}>
                  Resetuj hasło
              </button>
          </div>
          <div className="userView">
            <label htmlFor="role" className="userView">Rola</label>
            <input
                className="userView"
                type="text"
                id="role"
                name="role"
                value={formData.role}
                onChange={handleInputChange}
                readOnly={true}
            />
          </div>
            {/*<button type="submit" disabled={isSubmitDisabled}>*/}
            {/*  Dodaj*/}
            {/*</button>*/}
        </form>
      </> }
          {/*-----------------------------
              sex: '',
              gpsPoint: '',
              yearOfBirth: '',
              profilePhoto: null,
              otherPhotos: [],
          ---------------------------------*/}
      { modalViewActualTab === "Dane dodatkowe" && <>
        <form onSubmit={handleSubmit}>
          <div className="userView">
            <label htmlFor="sex" className="userView">Płeć</label>
            <input
                className="userView"
                type="text"
                id="sex"
                name="sex"
                value={formData.sex}
                onChange={handleInputChange}
                readOnly={true}
            />
          </div>
          <div className="userView">
            <label htmlFor="gpsPoint" className="userView">Lokalizacja</label>
            <input
                className="userView"
                type="text"
                id="gpsPoint"
                name="gpsPoint"
                value={formData.gpsPoint}
                onChange={handleInputChange}
                readOnly={true}
            />
          </div>
          <div className="userView">
            <label htmlFor="yearOfBirth" className="userView">Rok urodzenia</label>
            <input
                className="userView"
                type="text"
                id="yearOfBirth"
                name="yearOfBirth"
                value={formData.yearOfBirth}
                onChange={handleInputChange}
                readOnly={true}
            />
          </div>

          <div className="userView">
            <label htmlFor="profileimage" className="userView">Zdjęcie profilowe</label>
            <div id="profileimage" className="modal-image-preview">
                  <img src={formData.profilePhoto} alt="Podgląd miniatury" className="modal-image-preview-img" />
            </div>
          </div>
          <div className="userView">
            <label htmlFor="otherPhotos" className="userView">Zdjęcia dodatkowe</label>
            <div className="gallery-outer-container">
              {formData.otherPhotos && formData.otherPhotos.length > 0 ? (
                  <div className="gallery-with-masks">
                    {formData.otherPhotos.length > 3 && (
                        <div
                            className={`gallery-mask gallery-mask-left ${currentImageIndex === 0 ? 'disabled' : ''}`}
                            onClick={() => currentImageIndex > 0 && handleImageNavigation('prev')}
                        >
                          <div className="mask-arrow mask-arrow-left">&lt;</div>
                        </div>
                    )}

                    <div className="gallery-visible-area">
                      <div
                          className="gallery-scrollable-content"
                          style={{ transform: `translateX(-${currentImageIndex * (100/3)}%)` }}
                      >
                        {formData.otherPhotos.map((photoUrl, index) => (
                            <div key={index} className="gallery-image-wrapper">
                              <div className="gallery-image-container">
                                <img src={photoUrl} alt={`Zdjęcie ${index + 1}`} className="gallery-image" />
                              </div>
                            </div>
                        ))}
                      </div>
                    </div>

                    {formData.otherPhotos.length > 3 && (
                        <div
                            className={`gallery-mask gallery-mask-right ${currentImageIndex + 3 >= formData.otherPhotos.length ? 'disabled' : ''}`}
                            onClick={() => currentImageIndex + 3 < formData.otherPhotos.length && handleImageNavigation('next')}
                        >
                          <div className="mask-arrow mask-arrow-right">&gt;</div>
                        </div>
                    )}
                  </div>
              ) : (
                  <div className="no-images">Brak dodatkowych zdjęć</div>
              )}
            </div>
          </div>



          <div className="modal-margin-top-20">

            {/*<button type="submit" disabled={isSubmitDisabled}>*/}
            {/*  Dodaj*/}
            {/*</button>*/}
          </div>
        </form>
      </> }


      {/*-----------------------------
      otherSports: [],
          ---------------------------------*/}
      { modalViewActualTab === "Dyscypliny" &&
      <>
        <div className="userView-section">
          <label className="userView-section-label">Dyscypliny sportowe</label>
          <div className="sports-grid">
            {formData.otherSports && formData.otherSports.length > 0 ? (
                formData.otherSports.map((sport, index) => (
                    <div key={index} className={sport.name === formData.mostPracticedSport ? "sport-item-highlighted" : "sport-item"}>
                      <div className="sport-icon">
                        <img src={sport.icon} alt={sport.name} />
                      </div>
                      <div className="sport-details">
                        <div className="sport-name">{sport.name}</div>
                        <div className="sport-score">Ocena: {sport.score}/10</div>
                      </div>
                    </div>
                ))
            ) : (
                <div className="no-sports">Brak dyscyplin sportowych</div>
            )}
          </div>
        </div>

      </>}


      {/*-----------------------------
          opinions: [],
          ---------------------------------*/}
    { modalViewActualTab === "Opinie" &&
        <>
            <div className="userView-section">
                <label className="userView-section-label">Opinie</label>
                {formData.opinions && formData.opinions.length > 0
                    // &&
                    // formData.opinions.every(opinion => Array.isArray(opinion))

                    ? (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', height: '100%'}}>
                                <CustomText text={formData.avgScore} baseClass={'custom-text-green-negative-2'} />
                                {[...Array(formData.avgScore)].map((_, index) => (
                                    <StarFilled key={index} />
                                ))}
                                {[...Array(5 - formData.avgScore)].map((_, index) => (
                                    <StarEmpty key={index} />
                                ))}
                                <CustomText text={"(Liczba opinii: " + formData.numberOfOpinions + ")"} />
                            </div>

                    <Table
                        headers={getHeaders()}
                        rows={formData.opinions}
                        columnWidths={headerWidthsForUserOpinions}
                        idViewing={true}
                        idArrayId={0}
                        cellClass2='cell-center'
                        cellClass2ConditionList={[0,1,2,3]}
                        onRowClick={handleOpinionRowClick}/>
                    </>
                ) : (
                    <div className="no-sports">Brak opinii</div>
                )}
            </div>

          </>}

        {/*-----------------------------
              payments: [],
              ---------------------------------*/}
        { modalViewActualTab === "Płatności" &&
            <>
                <div className="userView-section">
                    <label className="userView-section-label">Historia płatności</label>
                    {formData.payments && formData.payments.length > 0 ? (
                        <Table
                            headers={['ID', 'Data', 'Kwota', 'Status', 'Opis']}
                            rows={formData.payments}
                            columnWidths={['10%', '20%', '15%', '15%', '40%']}
                            idViewing={true}
                            idArrayId={0}
                            cellClass2='cell-center'
                            cellClass2ConditionList={[0, 1, 2, 3]}
                        />
                    ) : (
                        <div className="no-sports">Brak historii płatności</div>
                    )}
                </div>
            </>
        }

        </div>
        {/* DODANY KONTENER PRZEWIJANIA - KONIEC */}

        {/*-=----------------------------*/}
        {/*<div>*/}
        {/*  <label htmlFor="thumbnail">Miniatura</label>*/}
        {/*  <input*/}
        {/*    type="file"*/}
        {/*    id="thumbnail"*/}
        {/*    name="thumbnail"*/}
        {/*    accept="image/*"*/}
        {/*    onChange={handleFileChange}*/}
        {/*  />*/}
        {/*  {imagePreview && (*/}
        {/*    <div className="modal-image-preview">*/}
        {/*      <img src={imagePreview} alt="Podgląd miniatury" className="modal-image-preview-img" />*/}
        {/*    </div>*/}
        {/*  )}*/}
        {/*</div>*/}

        {<div className="modal-margin-top-20">
            <button className="buttons-modal-appearance-almost-white" type="button" onClick={handleCloseModal}>
                Zamknij
            </button>
            {blocked === false ?
            <button className="buttons-modal-appearance-almost-white" type="button" onClick={handleZablokujOblokuj}>Zablokuj</button> : <button className="buttons-modal-appearance-almost-white" type="button" onClick={handleZablokujOblokuj}>Odblokuj</button>}

            </div>}

    </Modal>
  );
}

export default ViewUser;